import { Users } from 'lucide-react';

export function PanelInterviewTab() {
    return (
        <div className="px-5 py-12 text-center" style={{ color: 'var(--text-tertiary)' }}>
            <Users
                size={22}
                strokeWidth={1.5}
                style={{ display: 'inline', marginBottom: 10, color: 'var(--text-quaternary)' }}
            />
            <div className="text-[14px]" style={{ color: 'var(--text-secondary)' }}>
                No panel interview scheduled yet.
            </div>
            <div className="text-[12.5px] mt-1.5" style={{ color: 'var(--text-quaternary)' }}>
                Once a panel runs, scorecards from each interviewer will appear here.
            </div>
        </div>
    );
}
